import { DaysPerWeek } from '../types/onboarding';

// SCIO Exam Dates for 2026
export const SCIO_EXAM_DATES = [
    { date: '2026-02-28', label: '28. února', registrationDeadline: '12. 2.' },
    { date: '2026-03-28', label: '28. března', registrationDeadline: '12. 3.' },
    { date: '2026-04-25', label: '25. dubna', registrationDeadline: '9. 4.' },
    { date: '2026-05-23', label: '23. května', registrationDeadline: '7. 5.' }
] as const;

export const WEEKDAY_MAPPING: Record<DaysPerWeek, string[]> = {
    2: ['Tue', 'Sat'],
    3: ['Mon', 'Wed', 'Sat'],
    4: ['Mon', 'Wed', 'Fri', 'Sun'],
    5: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
    7: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
};

export const OSP_LABELS: Record<string, string> = {
    logic: 'Logika',
    reading: 'Práce s textem',
    data: 'Tabulky a data',
    unsure: 'Všeobecný přehled'
};

export const ZSV_LABELS: Record<string, string> = {
    filosofie: 'Filosofie',
    sociologie: 'Sociologie',
    politologie: 'Politologie',
    ekonomie: 'Ekonomie',
    unsure: 'Základy spol. věd'
};

export const MODULE_LABELS: Record<string, string> = {
    OSP: 'OSP',
    ZSV: 'ZSV'
};
